import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { retry, map, catchError } from 'rxjs/operators';
import { Agent } from './agent.model';

@Injectable({
  providedIn: 'root'
})
export class AgentService {

  constructor(public http: HttpClient) { }

  getAgents(): Observable<Agent[]> {
    return this.http.get<Agent[]>(`/api/agents`)
      .pipe(
        retry(3),
        map(
          result => result
        ),
        catchError(this.errorHandler)
      );
  }

  getAgent(id: string): Observable<Agent> {
    return this.http.get<Agent>(`/api/agents/${id}`)
      .pipe(
        retry(3),
        map(
          result => result
        ),
        catchError(this.errorHandler)
      );
  }

  private errorHandler(error: HttpErrorResponse): Observable<never> {
    console.error('Fehler aufgetreten!');
    return throwError(error);
  }
}
